export const SEAMLESS_PLUGIN_ID = 'seamless';
export const NOT_FOUND = 'not found';
